import { client } from './client'
import type { WorkflowRunApprovalRequest } from '@/types'

export const workflowApprovalsApi = {
  getPending: (projectId: string) =>
    client.get<WorkflowRunApprovalRequest[]>(`/projects/${projectId}/workflow-approvals/pending`).then(r => r.data),

  approve: (projectId: string, phaseId: string, comment?: string) =>
    client.post<{ phaseId: string }>(`/projects/${projectId}/workflow-approvals/${phaseId}/approve`, { comment })
      .then(r => r.data),

  reject: (projectId: string, phaseId: string, reason: string) =>
    client.post<{ phaseId: string }>(`/projects/${projectId}/workflow-approvals/${phaseId}/reject`, { reason })
      .then(r => r.data),
}
